export const namespaced = true;

export const state = {
    pages: [],
    page_el: {},
    types: [],
    meta: null,
    page: 1,
    per_page: 25,
    loading: false,
}

export const mutations = {
    FETCH_PAGES(state, pages) {
        state.pages = pages;
    },
    FETCH_PAGE(state, page_el) {
        state.page_el = page_el;
    },
    FETCH_META(state, meta) {
        state.meta = meta;
    },
    ADD_PAGE(state) { },
    SET_PAGE(state, page) {
        state.page = page;
    },
    SET_PER_PAGE(state, per_page) {
        state.per_page = per_page;
    },
    PAGES_REMOVE(state) { },
    PAGES_BLOCK(state) { },
}

export const actions = {

    async fetch({ commit, state, dispatch }) {
        try {
            const res = (await axios.get(`/api/admin/pages`, {
                params: {
                    page: state.page,
                    per_page: state.per_page
                }
            })).data;
            commit('FETCH_PAGES', res.data);
            commit('FETCH_META', res.meta);
            return res.data;
        } catch (error) {
            const notification = {
                page: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    async fetchPage({ commit, state, dispatch }, page_id) {
        try {
            const res = (await axios.get(`/api/admin/pages/${page_id}`)).data;
            commit('FETCH_PAGE', res.data.page);
            return res.data.page;
        } catch (error) {
            const notification = {
                page: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    setPage({ commit, state, dispatch }, page) {
        commit('SET_PAGE', page);
    },

    setPerPage({ commit, state, dispatch }, per_page) {
        commit('SET_PAGE', 1);
        commit('SET_PER_PAGE', per_page);
    },

    async block({ commit, state, dispatch }, { deletes, status }) {
        if (deletes.length) {
            try {
                let formDataPost = new FormData();

                for (const i of deletes) {
                    formDataPost.append('blocked[]', i);
                }
                formDataPost.append('status', status);

                const res = (
                    await axios.post(
                        `/api/admin/block-pages`, formDataPost
                    )
                ).data;

                commit('PAGES_BLOCK');

                dispatch('fetch');

                const notification = {
                    page: "success",
                    message: "Запрос успешно выполнен",
                };
                dispatch("notification/add", notification, { root: true });
            } catch (error) {
                const notification = {
                    page: 'error',
                    message: error.response && error.response.data && error.response.data.message
                }
                dispatch('notification/add', notification, { root: true });
                throw error;
            }
        } else {
            const notification = {
                page: 'error',
                message: 'Вы не выбрали ни одного типа'
            }
            dispatch('notification/add', notification, { root: true });
        }
    },

    async remove({ commit, state, dispatch }, deletes) {
        if (deletes.length) {
            try {
                let formDataPost = new FormData();

                for (const i of deletes) {
                    formDataPost.append('deletes[]', i);
                }

                const res = (
                    await axios.post(
                        `/api/admin/delete-pages`, formDataPost
                    )
                ).data;
                commit('PAGES_REMOVE');

                dispatch('fetch');

                const notification = {
                    page: "success",
                    message: "Удаление прошло успешно",
                };
                dispatch("notification/add", notification, { root: true });
            } catch (error) {
                const notification = {
                    page: 'error',
                    message: error.response && error.response.data && error.response.data.message
                }
                dispatch('notification/add', notification, { root: true });
                throw error;
            }
        } else {
            const notification = {
                page: 'error',
                message: 'Вы не выбрали ни одного типа'
            }
            dispatch('notification/add', notification, { root: true });
        }
    },

}
